export class SearchFilters extends HTMLDivElement {
    private toggleHandler: (e: MouseEvent) => void;
    private resizeHandler: () => void;
    private escapeHandler: (e: KeyboardEvent) => void;

    constructor() {
        super();

        this.toggleHandler = (e: MouseEvent) => {
            const target = (e.target as HTMLElement).closest('[data-toggle-filters]');
            if (!target) return;
            e.preventDefault();
            this.classList.toggle('opened');
            this.updateBodyScroll();
        };
        
        this.resizeHandler = () => {
            if (this.classList.contains('opened')) {
                this.classList.remove('opened');
                this.updateBodyScroll();
            }
        };

        this.escapeHandler = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && this.classList.contains('opened')) {
                this.classList.remove('opened');
                this.updateBodyScroll();
            }
        };
    }

    connectedCallback() {
        this.init();
        document.addEventListener('click', this.toggleHandler);
        document.addEventListener('keydown', this.escapeHandler);
        window.addEventListener('resize', this.resizeHandler);
        this.updateBodyScroll();
    }

    disconnectedCallback() {
        document.removeEventListener('click', this.toggleHandler);
        document.removeEventListener('keydown', this.escapeHandler);
        window.removeEventListener('resize', this.resizeHandler);
        document.body.style.overflow = '';
    }

    private updateBodyScroll() {
        if (this.classList.contains('opened')) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }

    private init() {

        const filterItemsLists = this.querySelectorAll('.filter-items');
        filterItemsLists.forEach((list) => {
            const limit = parseInt(list.getAttribute('data-limit') || '0', 10);
            const items = Array.from(list.children);
            if (limit > 0 && items.length > limit) {
                // Fonction pour replier la liste
                const collapse = () => {
                    items.forEach((item, idx) => {
                        (item as HTMLElement).style.display = idx < limit ? '' : 'none';
                    });
                    btn.textContent = 'Afficher plus';
                    btn.setAttribute('aria-expanded', 'false');
                };

                // Fonction pour déplier la liste
                const expand = () => {
                    items.forEach((item) => {
                        (item as HTMLElement).style.display = '';
                    });
                    btn.textContent = 'Afficher moins';
                    btn.setAttribute('aria-expanded', 'true');
                };

                // Initial collapse
                items.forEach((item, idx) => {
                    if (idx >= limit) {
                        (item as HTMLElement).style.display = 'none';
                    }
                });

                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'btn btn-link p-0 mt-2';
                btn.textContent = 'Afficher plus';
                btn.setAttribute('aria-expanded', 'false');

                let expanded = false;
                btn.addEventListener('click', () => {
                    expanded = !expanded;
                    if (expanded) {
                        expand();
                    } else {
                        collapse();
                    }
                });

                list.parentElement?.appendChild(btn);
            }
        });
    }

}
